import script from "./folder-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./folder-edit.vue?vue&type=script&setup=true&lang=js"

import "./folder-edit.vue?vue&type=style&index=0&id=15b263de&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b263de"]])

export default __exports__